import styled, {css} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import {Dimensions} from 'react-native';
import {isIphoneX} from 'react-native-iphone-screen-helper';

interface ICategoryProductProps {
  inactive?: boolean;
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  flex: 1;
`;

export const TitlesContainer = styled.View`
  padding: 0 24px;
  flex-direction: column;
gap:${RFValue(10)}px;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Empty = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(14)}px;
  text-align: center;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const HelpButtonContainer = styled.View`
  flex-direction: row;
`;

export const ContentHeader = styled.View`
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  justify-content: space-between;
`;

export const LinkButton = styled.TouchableOpacity`
  border-bottom-width: 2px;
  border-color: ${({theme}) => theme.colors.blue};
  border-style: solid;
  margin-left: ${RFValue(12)}px;
`;

export const LinkButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.blue};
`;

export const SelectProductCategoryContainer = styled.ScrollView``;

export const Row = styled.View`
  flex-direction: row;
  padding: 0 24px;
  width: 100%;
  justify-content: space-between;
  margin-top: ${RFValue(12)}px;
`;
export const ProductCategoryItem = styled.TouchableOpacity<ICategoryProductProps>`
  width: 50%;
  ${({inactive}) =>
    inactive &&
    css`
      opacity: 0.2;
    `}
`;

const imageDimensions = isIphoneX()
  ? Dimensions.get('window').width >= 393 &&
    Dimensions.get('window').width < 430
    ? RFValue(90)
    : Dimensions.get('window').width >= 394 &&
      Dimensions.get('window').width < 431
    ? RFValue(94)
    : RFValue(100)
  : RFValue(104);

//@ts-ignore
export const ProductCategoryImage = styled(FastImage)`
  height: ${imageDimensions}px;

  border-radius: ${RFValue(20)}px;
`;

export const LinksButtonContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const LocationContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  margin-bottom: ${RFValue(12)}px;
`;
export const LocationColumn = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const LocationIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.primary};
`;
export const LocationInfos = styled.View`
  flex-direction: column;
  margin-left: ${RFValue(12)}px;
`;
export const LocationText = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const LocationButton = styled.TouchableOpacity``;
export const ChangeLocationIcon = styled(FontAwesome)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;
